import { gsap } from 'gsap' ;
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { CSSPlugin } from 'gsap/CSSPlugin';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';

export default {
  init() {
    // JavaScript to be fired on the about us page
    console.log('arranca el entradas landing');

   
    gsap.registerPlugin(ScrollTrigger, CSSPlugin, ScrollToPlugin);
   //let altura = $('.btn-comprar').position();
    const tl3 = gsap.timeline({
      scrollTrigger: {
        trigger: '.seccion-secundaria',
        start: 'top 20%',
        end: '75% 90%',
        scrub: true,
        markers: false,
      },
    });
    tl3.to('.boton-entradas',{duration: 3, css: { position: 'fixed', right: '2vw', zIndex: 9999}}),
    tl3.to('.boton-entradas',{duration: 3, css: { top: '1vh'}}),
    tl3.to('.boton-entradas',{duration: 3, css: { maxWidth: '225px'}});

   
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/landing-sorteo.js